"use strict";

exports.__esModule = true;
exports.pathToFieldName = pathToFieldName;
/**
 * Convert a layout path to a final form field name.
 */
function pathToFieldName(path) {
  var parts = [];
  for (var i = 0; i < path.length; i++) {
    var item = path[i];
    if (typeof item === "number") {
      parts.push("[" + item + "]");
    } else if (i > 0) {
      parts.push("." + item);
    } else {
      parts.push(item);
    }
  }
  return parts.join("");
}